export default __webpack_public_path__ + "static/media/Demolish_rune.064b2fc5.png";